/*
 * @Author: Fan
 * @Date: 2020-04-26 12:13:42
 * @description:
 * @LastEditors: Fan
 */
// import Rate from "./Rate";
import DropdownTags from "./DropdownTags";
import DataSelect from "./DataSelect";
import WorkReport from "./WorkReport";
import CustomRichText from './RichText';
// import CustomButton from "./CustomButton";
export default [/* Rate */ DropdownTags, DataSelect, WorkReport, CustomRichText /* , CustomButton, SheetCard */];
